import { OptionModel } from "components/helpers"
import { MultiSelect, ValidationMessage } from "components/library"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useGetProductCodesByCalculationType } from "./hook/useGetProductCodesByCalculationType"

interface Props {
  calculationTypeId: number
  agreements: number[]
  rebates: number[]
  rates: number[]
  errorMessage?: string
  displayValidations?: boolean
  fieldName: string
  heading: string
  required?: boolean
  onChange: (e: any) => void
  selectedItems: any[]
  disabled?: boolean
}

export const ProductCodeByCalculationTypeMultiselect: React.FC<Props> = ({
  calculationTypeId,
  agreements,
  rebates,
  rates,
  errorMessage,
  displayValidations,
  fieldName,
  heading,
  required,
  onChange,
  selectedItems,
  disabled,
}) => {
  const { t } = useTranslation()
  const [searchTimeout, setSearchTimeout] = useState<any>()
  const [query, setQuery] = useState<string>("")
  const { productCodesByCalculationType } = useGetProductCodesByCalculationType(
    calculationTypeId,
    agreements,
    rebates,
    query
  )
  const [productCodeList, setProductCodeList] = useState<OptionModel[]>([])

  const [productCodesSelected, setProductCodesSelected] = useState<
    OptionModel[]
  >(
    selectedItems
      ? selectedItems.map((item) => ({
          value: item,
          title: item,
          hidden: true,
        }))
      : []
  )
  const textChanged = (event: any) => {
    clearTimeout(searchTimeout)
    setSearchTimeout(
      setTimeout(() => {
        setQuery(event.filter)
      }, 500)
    )
  }

  const getSelectedProductCodeValue = (ids: string[]) => {
    const productCodeSelectedButNotInList = ids
      .filter((p) => !productCodeList.map((c) => c.value).includes(p))
      ?.map((c) => ({
        value: c,
        title: productCodesSelected.find((psi) => psi.value === c)?.title ?? c,
        hidden: true,
      }))
    const options = productCodeList.concat(productCodeSelectedButNotInList)
    setProductCodeList(options)

    const selectedItems = ids.map((c) => ({
      value: c,
      title:
        productCodeList?.find((aps) => aps.value === c)?.title ??
        productCodesSelected.find((psi) => psi.value === c)?.title ??
        c,
      hidden: true,
    }))
    return selectedItems
  }

  React.useEffect(() => {
    if (
      productCodesByCalculationType.data &&
      productCodesByCalculationType.data.length > 0
    ) {
      const productCodeSelectedButNotInList =
        selectedItems.length > 0
          ? productCodesSelected
              .filter(
                (us) =>
                  !productCodesByCalculationType.data
                    .map((u) => u.value)
                    .includes(us.value)
              )
              ?.map((us) => ({
                value: us.value,
                title: us.title,
                hidden: true,
              }))
          : []

      const productCodesTemp = productCodesByCalculationType.data.concat(
        productCodeSelectedButNotInList
      )
      setProductCodeList(productCodesTemp)
    } else {
      setProductCodeList([])
    }
  }, [productCodesByCalculationType.data])
  return (
    <>
      <MultiSelect
        options={productCodeList}
        required={required}
        optionLabel="title"
        optionValue="value"
        name={fieldName}
        heading={heading}
        value={productCodeList?.length > 0 ? selectedItems : []}
        onChange={(e) => {
          onChange(e)
          setProductCodesSelected(getSelectedProductCodeValue(e.value))
        }}
        onFilter={(e) => {
          textChanged(e)
        }}
        placeholder={
          productCodesByCalculationType.data &&
          productCodesByCalculationType.data?.length < 1
            ? t("no-records-found")
            : t("select-options")
        }
        disabled={disabled}
      />
      {errorMessage && displayValidations && (
        <ValidationMessage
          messageError={errorMessage}
          showMessage={
            displayValidations &&
            errorMessage !== undefined &&
            errorMessage !== null &&
            errorMessage.length > 0
          }
        />
      )}
    </>
  )
}
